import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const NavigationButtons = ({ prevID, nextID }) => {
  return (
    <div className="flex gap-4">
      <LeftOutlined id={prevID} className="bg-white hover:text-primary-hover border-2 border-gray-300 hover:border-primary p-2 rounded-full " />
      <RightOutlined id={nextID} className="bg-white hover:text-primary-hover border-2 border-gray-300 hover:border-primary p-2 rounded-full " />
    </div>
  );
};

export default NavigationButtons;
